import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { CfcService } from '../cfc.service';
import { AuthService } from '../../admin/auth.service';
import { UnidadeService } from '../../shared/services/unidade.service';

@Component({
  templateUrl: './gerenciar-cfc.component.html',
})
export class GerenciarCfcComponent extends WebPage implements OnInit {

public cfcUnidades;
public unidades;
public status;
  constructor(private cfcService: CfcService,
    private authService: AuthService,
    private unidadeService: UnidadeService,
    messageService: MessageService) {
    super(messageService);
  }

  ngOnInit() {
    const usuario = this.authService.informacoesUsuario();

    const observable = (usuario.Perfil !== '#GESTORUNIDADEOPERACIONAL' && usuario.Perfil !== '#ADMINISTRATIVOUNIDADEOPERACIONAL')
      ? this.cfcService.getAllCfcUnidades()
      : this.cfcService.getCfcUnidadesByUnidade(usuario.IdUnidade);

    this.isLoading = true;
    observable
      .finally(() => this.isLoading = false)
      .subscribe(
        cfcUnidades => {
          this.cfcUnidades = cfcUnidades;
          // console.table(cfcUnidades);
          this.status = this.cfcUnidades.map(x => x.statusCredenciamento.descricao)
                                        .filter((value, index, self) => self.indexOf(value) === index)
                                        .sort((one, two) => (one > two ? 1 : -1));

        },
        error => this.gerenciaErro(error)
      );
      this.getUnidadeCfc();
  }

  exibirGerenciaDeTermos(cfcUnidade) {
    return ((new Date(cfcUnidade.dataValidadeCredenciamento) > new Date()) && cfcUnidade.statusCredenciamento.descricao !== 'Cadastrado');
  }

  getUnidadeCfc() {
    this.unidadeService.getUnidadesCfc()
      .finally(() => this.isLoading = false)
      .subscribe(
        unidades => {
          this.unidades = unidades;
          // console.log(unidades);
        },
        error => this.gerenciaErro(error)
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cfc/gerenciar-cfc/gerenciar-cfc.component.ts